module.exports = __webpack_public_path__ + "static/media/bitdefender-off.c6291287.jpg";